module.exports = __webpack_public_path__ + "img/Weapon_187.b086afdf.png";